import Swal from "sweetalert2";
import { Path } from "../../Api/Path";

const STYLE_ID = "dx-swal-toast-style";
const toastCss = `
  .swal2-high-z-index {
    z-index: 300000 !important;
  }

  .dx-swal-toast-container.swal2-top-end {
    padding: 18px 18px 0 0 !important;
  }

  .dx-swal-toast.swal2-popup {
    width: auto !important;
    max-width: min(400px, calc(100vw - 28px)) !important;
    padding: 0 !important;
    background: #ffffff !important;
    border: 1px solid #e3eee3 !important;
    border-radius: 14px !important;
    box-shadow:
      0 16px 36px rgba(18, 40, 18, 0.12),
      0 2px 6px rgba(18, 40, 18, 0.05) !important;
    overflow: hidden;
  }

  .dx-swal-toast .swal2-html-container {
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    text-align: left !important;
  }

  .dx-swal-toast.swal2-popup.swal2-toast {
    display: flex !important;
    flex-direction: column !important;
    align-items: stretch !important;
  }

  .dx-toast {
    display: flex;
    align-items: flex-start;
    gap: 12px;
    padding: 14px 16px 16px;
    text-align: left;
    font-family: "Be Vietnam Pro", "Inter", sans-serif !important;
  }

  .dx-toast--compact {
    align-items: center;
    padding-top: 12px;
    padding-bottom: 13px;
  }

  .dx-toast__mark {
    flex: 0 0 34px;
    width: 34px;
    height: 34px;
    margin-top: 1px;
    border-radius: 50%;
    background: #e8f6e7;
    color: #039700;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .dx-toast--compact .dx-toast__mark {
    margin-top: 0;
  }

  .dx-toast__copy {
    min-width: 220px;
    max-width: 286px;
    display: flex;
    flex-direction: column;
    gap: 3px;
  }

  .dx-toast__lead,
  .dx-toast__detail {
    margin: 0;
    font-family: inherit;
  }

  .dx-toast__lead {
    font-size: 14px;
    font-weight: 600;
    line-height: 1.45;
    color: #173017;
  }

  .dx-toast__detail {
    font-size: 13px;
    font-weight: 400;
    line-height: 1.5;
    color: #516351;
    text-wrap: balance;
  }

  .dx-swal-toast .swal2-timer-progress-bar-container {
    height: 3px !important;
  }

  .dx-swal-toast .swal2-timer-progress-bar {
    background: #039700 !important;
  }

  @media (max-width: 480px) {
    .dx-swal-toast-container.swal2-top-end {
      padding: 12px 12px 0 0 !important;
    }

    .dx-toast__copy {
      min-width: 0;
      max-width: 230px;
    }
  }
`;

const existingStyle = document.getElementById(STYLE_ID);
if (existingStyle) {
  existingStyle.textContent = toastCss;
} else {
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = toastCss;
  document.head.appendChild(style);
}

const escapeHtml = (value) =>
  String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");

const splitToastMessage = (message) => {
  const raw = String(message ?? "")
    .replace(/\s+/g, " ")
    .trim();
  if (raw.length < 56) return { title: raw, text: "" };

  const match = raw.match(/^(.+?[.!?])\s+(.+)$/u);
  if (!match) return { title: raw, text: "" };

  return { title: match[1], text: match[2] };
};

const CHECK_ICON = `<span class="dx-toast__mark" aria-hidden="true"><svg viewBox="0 0 24 24" width="18" height="18" fill="none"><path d="M5.5 12.5 10 17l8.5-9.5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg></span>`;

export const SwalSuccess = (Prtitle) => {
  const { title, text } = splitToastMessage(Prtitle);
  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: text ? 5200 : 2800,
    timerProgressBar: true,
    customClass: {
      container: "swal2-high-z-index dx-swal-toast-container",
      popup: "dx-swal-toast",
      htmlContainer: "dx-swal-toast-html",
    },
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  Toast.fire({
    html: `<div class="dx-toast${text ? "" : " dx-toast--compact"}">${CHECK_ICON}<div class="dx-toast__copy"><p class="dx-toast__lead">${escapeHtml(title)}</p>${text ? `<p class="dx-toast__detail">${escapeHtml(text)}</p>` : ""}</div></div>`,
  });
};

export const SwalFail = (Prtitle) => {
  Swal.fire({
    title: Prtitle,
    confirmButtonText: "Đóng",
    customClass: {
      container: "swal2-high-z-index",
    },
    showClass: {
      popup: "animate__animated animate__fadeInDown",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutUp",
    },
  });
};

export const SwalQuesionYN = (title) => {
  let isAccess = false;
  Swal.fire({
    title: title,
    showDenyButton: true,
    confirmButtonText: "Đồng ý",
    denyButtonText: `hủy`,
  }).then((result) => {
    if (result.isConfirmed) {
      isAccess = true;
    }
  });
  return isAccess;
};

export const SwalError = (Prtitle) => {
  Swal.fire({
    title: Prtitle,
    confirmButtonText: "Liên hệ",
    customClass: {
      container: "swal2-high-z-index",
    },
    showClass: {
      popup: "animate__animated animate__fadeInDown",
    },
    hideClass: {
      popup: "animate__animated animate__fadeOutUp",
    },
  }).then((result) => {
    if (result.isConfirmed) {
      // Mở một tab mới
      const url = Path.SUPPORT;
      const link = document.createElement("a");
      link.href = url;
      link.target = "_blank";
      link.click();
    }
  });
};
